export default "__VITE_ASSET__CPGrPf7i__"